import type { WhatsAppTranslations } from '../interfaces/whatsapp';

export const whatsAppTranslations: WhatsAppTranslations = {
  chatTitle: 'Chat',

  integrationSectionTitle: 'WhatsApp Business',
  integrationSectionDescription:
    'Connect your WhatsApp Business account so your agent can receive and reply to messages on your behalf.',
  connectCardTitle: 'Connect your WhatsApp Business',
  connectCardDescription:
    'We will redirect you to Meta to authorize the connection, pick your phone number, and grant the required permissions. You stay in control of what gets authorized.',
  connectButton: 'Connect my WhatsApp Business',
  connectingLabel: 'Connecting…',
  connectedBadge: 'Connected',
  connectedAtLabel: 'Connected on',
  verifiedNameLabel: 'Verified name',
  phoneNumberLabel: 'Phone number',
  businessIdLabel: 'Business portfolio ID',
  businessIdMissing: 'Not available — reconnect to manage templates',
  wabaIdLabel: 'WABA ID',
  phoneNumberIdLabel: 'Phone Number ID',
  technicalDetailsLabel: 'Technical details',
  reconnectButton: 'Reconnect with another account',
  syncPhonesButton: 'Sync phone numbers',
  syncPhonesSuccess: 'Phone numbers synced',
  syncPhonesError: 'Could not sync phone numbers',
  reconnectDialogTitle: 'Reconnect your WhatsApp Business?',
  reconnectDialogDescription:
    'This will replace the current connection with the new account you choose in Meta.',
  reconnectDialogConfirm: 'Yes, reconnect',
  reconnectDialogCancel: 'Cancel',
  switchToManualButton: 'Switch to access token',
  disconnectButton: 'Disconnect',
  disconnectDialogTitle: 'Disconnect WhatsApp Business?',
  disconnectDialogDescription:
    'Your agent will stop receiving and replying to messages on this number. You can connect it again whenever you want, with Facebook or with an access token.',
  disconnectDialogConfirm: 'Yes, disconnect',
  disconnectDialogCancel: 'Cancel',
  disconnectSuccess: 'WhatsApp disconnected.',
  disconnectError: 'We could not disconnect your WhatsApp. Please try again.',
  sdkLoadError:
    'We could not load the Facebook SDK. Disable your adblocker or check your connection.',
  cancelledMessage: 'You closed the Meta dialog before finishing.',
  successToast: 'WhatsApp connected successfully!',
  errorStepExchangeCode:
    'The process expired. Please start the connection again from scratch.',
  errorStepDebugToken:
    'We could not validate your WhatsApp Business account. Make sure it is properly set up in Meta.',
  errorStepVerifyToken:
    'The token you pasted is not authorized for that WhatsApp Business Account. Double-check the WABA ID and the token scopes.',
  errorStepPhoneNumbers:
    'Your WhatsApp Business account does not have a phone number. Register one in Meta Business Suite and try again.',
  errorStepSubscribeApps:
    'We could not subscribe to your WhatsApp messages. If another platform is connected, disconnect it first.',
  errorStepPersist:
    'There was an error saving your connection. Please try again in a moment.',
  errorStatusLoad:
    'We could not load your connection status. Please try again.',
  errorUnknown: 'An unexpected error occurred. Please try again.',
  retryButton: 'Retry',
  redirectDisclaimer:
    'We will redirect you to Meta to authorize. You control the permissions.',

  configureButton: 'Configure channel',
  tilePhonesCount: '{{count}} number',
  drawerTitle: 'WhatsApp Business · channel',
  drawerDescription:
    'Connection details, default agent and per-number bindings.',

  manualConnectLink: 'Connect with credentials',
  manualDrawerTitle: 'Connect with credentials',
  manualDrawerDescription:
    'Already have a System User token from Meta Business Manager? Paste it here together with your WABA ID and we will validate and register your account.',
  manualAccessTokenLabel: 'Access token',
  manualAccessTokenPlaceholder: 'EAAGm0PX...',
  manualAccessTokenHelp:
    'Long-lived System User token with whatsapp_business_management and whatsapp_business_messaging scopes.',
  manualWabaIdLabel: 'WhatsApp Business Account ID',
  manualWabaIdPlaceholder: '102290129340398',
  manualWabaIdHelp:
    'Numeric ID of the WABA the token is authorized for. You can find it in Meta Business Manager.',
  manualBusinessIdLabel: 'Business portfolio ID (optional)',
  manualBusinessIdPlaceholder: '1174430681268289',
  manualBusinessIdHelp: 'Found under Business settings → Business info. Without it you will not be able to create or sync templates.',
  manualBusinessIdInvalid: 'The ID can only contain digits',
  manualSubmit: 'Connect',
  manualReplaceSubmit: 'Replace connection',
  manualReplaceWarningTitle: 'You already have an account connected',
  manualReplaceWarningDescription:
    'Continuing replaces the current connection (WABA {{wabaId}}) with whatever these credentials authorize.',
  manualSuccess: 'WhatsApp connected successfully!',
  manualAccessTokenRequired: 'Paste your access token to continue.',
  manualWabaIdRequired: 'Enter your WABA ID to continue.',
  manualWabaIdInvalid: 'The WABA ID must be numeric.',

  manualGuideTitle: 'How to get these credentials',
  manualGuideStep1:
    'Open Meta Business Manager and pick the business that owns your WhatsApp account.',
  manualGuideStep1Link: 'Open Business Manager',
  manualGuideStep2:
    'In Business Settings → Accounts → WhatsApp Accounts, select your WABA and copy its ID (visible in the URL and in the side panel).',
  manualGuideStep2Link: 'Open WhatsApp Accounts',
  manualGuideStep3:
    'In Business Settings → Users → System Users, create or pick a System User, click "Generate new token", select your Meta App and the scopes below, and copy the token.',
  manualGuideStep3Link: 'Open System Users',
  manualGuideScopes:
    'Required token scopes: whatsapp_business_management and whatsapp_business_messaging.',
  manualGuideDocsLink: 'Read the official Meta guide',
};
